var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.transitionName } }, [
    _vm.isVisible
      ? _c("div", { ref: "modal", staticClass: "modal" }, [
          _c("div", {
            staticClass: "modal-backdrop",
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "modal-content",
              staticClass: "modal-container bg-cl-primary",
              style: _vm.style
            },
            [
              _vm.$slots.header
                ? _c(
                    "header",
                    {
                      staticClass:
                        "modal-header py25 px65 h1 serif weight-700 bg-cl-secondary"
                    },
                    [
                      _vm._t("header"),
                      _vm._v(" "),
                      _c(
                        "i",
                        {
                          staticClass:
                            "modal-close material-icons cl-bg-tertiary",
                          attrs: {
                            slot: "close",
                            "data-testid": "closeModalButton"
                          },
                          on: { click: _vm.close },
                          slot: "close"
                        },
                        [_vm._v("\n          close\n        ")]
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.content
                ? _c(
                    "div",
                    {
                      staticClass: "modal-content bg-cl-primary pt30 pb60 px65"
                    },
                    [_vm._t("content")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }